import React from 'react';
import { Box, Typography, Button } from '@mui/material';
import { Info as InfoIcon, Edit as EditIcon, WhatsApp as WhatsAppIcon } from '@mui/icons-material';

interface TripInformationHeaderProps {
  isEditing: boolean;
  loading: boolean;
  customer: { mobileNumber?: string } | null;
  disabled: boolean;
  onModify: () => void;
  onOpenWhatsAppDialog: () => void;
  onOpenReminderDialog: () => void;
  isInProgress?: boolean;
  isCompleted?: boolean;
}

const TripInformationHeader: React.FC<TripInformationHeaderProps> = ({
  isEditing,
  loading,
  customer,
  disabled,
  onModify,
  onOpenWhatsAppDialog,
  onOpenReminderDialog,
  isInProgress,
  isCompleted
}) => (
  <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', backgroundColor: '#464545', color: 'white', p: 2, borderRadius: '8px 8px 0 0' }}>
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
      <InfoIcon />
      <Typography variant="h6" fontWeight="bold">
        Trip Information
      </Typography>
    </Box>
    <Box sx={{ display: 'flex', gap: 1 }}>
      {!isEditing && (
        <>
          <Button 
            variant="contained" 
            color="success"
            onClick={onOpenWhatsAppDialog}
            startIcon={<WhatsAppIcon />}
            disabled={loading || !customer?.mobileNumber || disabled || isInProgress || isCompleted}
            sx={{ bgcolor: '#25D366', color: 'white', '&:hover': { bgcolor: '#128C7E' } }}
          >
            Send Trip Confirmation
          </Button>
          <Button 
            variant="contained" 
            color="warning"
            onClick={onOpenReminderDialog}
            startIcon={<WhatsAppIcon />}
            disabled={loading || !customer?.mobileNumber || disabled || isInProgress || isCompleted}
            sx={{ bgcolor: '#FF9800', color: 'white', '&:hover': { bgcolor: '#F57C00' } }}
          >
            Send Trip Reminder
          </Button>
          <Button 
            variant="contained" 
            color="primary"
            onClick={onModify}
            startIcon={<EditIcon />}
            disabled={loading || disabled}
            sx={{ bgcolor: 'white', color: '#0891b2', '&:hover': { bgcolor: '#e0f2fe' } }}
          >
            Modify
          </Button>
        </>
      )}
    </Box>
  </Box>
);

export default TripInformationHeader;